module.exports = __webpack_public_path__ + "static/media/calendar-arrow.0dbc970c.svg";